import { Component, Inject, Injector, OnInit, Type, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CustomFormTypes,
  DataForCustomFormModel
} from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { CustomFormDirective } from '@bo-client/shared/directives/custom-form-directive';
import { CustomFormComponent } from '@bo-client/activation-management/custom-form.component';

/**
 * Dynamishce Komponente
 */
@Component({
  selector: 'app-custom-form-modal',
  templateUrl: './custom-form-modal.component.html',
  styleUrls: ['./custom-form-modal.component.scss']
})
export class CustomFormModalComponent implements OnInit {
  @ViewChild(CustomFormDirective, { static: true })
  customFormHost!: CustomFormDirective;

  // In your component class
  public currentFormConfig: Type<CustomFormComponent<any, any>>;

  constructor(
    public dialogRef: MatDialogRef<CustomFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DataForCustomFormModel<unknown>,
    private injector: Injector // Inject the parent injector
  ) {
    this.currentFormConfig = data.actionInfo.customForm;
  }

  ngOnInit(): void {
    // put the form in :)
    const viewContainerRef = this.customFormHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<CustomFormComponent<unknown, unknown>>(
      this.currentFormConfig
    );
    componentRef.instance.data = this.data;
    componentRef.instance.onConfirm.subscribe(this.confirm.bind(this));
  }

  cancel() {
    this.dialogRef.close(null);
  }

  confirm(outputData: unknown) {
    // Update 'any' with correct type if needed
    this.dialogRef.close(outputData || null);
  }
}
